import React from "react";
import "./footer.css";
import { me } from "@data/me";

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer__container container">
                <h1 className="footer__title">{me.displayName}</h1>
                
                {/* <ul className="footer__list">
                    <li>
                        <a href="#about" className="footer__link">About</a>
                    </li>

                    <li>
                        <a href="#qualification" className="footer__link">Qualification</a>
                    </li>

                    <li>
                        <a href="#certifications" className="footer__link">Certification</a>
                    </li>
                </ul> */}

                <div className="footer__social">
                    <a href={me.socialLinks.linkedin} className="footer__social-link" target="_blank" rel="noreferrer">
                        <i className="bx bxl-linkedin"></i>
                    </a>

                    <a href={me.socialLinks.twitter} className="footer__social-link" target="_blank" rel="noreferrer">
                        <i className="bx bxl-twitter"></i>
                    </a>

                    <a href={me.socialLinks.instagram}className="footer__social-link" target="_blank" rel="noreferrer">
                        <i className="bx bxl-instagram"></i>
                    </a>
                </div>

                <span className="footer__copy">&#169; oo7mza. All rigths reserved [@Cryptical Coder]</span>
            </div>
        </footer>
    );
};

export default Footer;